module.exports = __webpack_public_path__ + "static/media/img_5.88cf1d03.png";